/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2026 (original work) Open Assessment Technologies SA
 */

import { createMomentLocaleLoaders } from '@oat-sa-private/ui-core/time/momentLocaleLoaders.internal.js';
import { setMomentLocale } from '@/core/utils/setMomentLocale.js';

/**
 * Rollup-compatible runtime loader for moment locale files.
 * @param {string} localeName
 * @returns {Promise<void>}
 */
async function loadRollupMomentLocale(localeName) {
    await setMomentLocale(localeName.toLowerCase());
}

const loaders = createMomentLocaleLoaders({}, {}, loadRollupMomentLocale);

export const { getMomentLocaleCandidates, getMomentLocaleLoader, hasMomentLocaleDiscovery } = loaders;
